var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-cn"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"main-bd mg20"},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[(_vm.loginRule != null && _vm.loginRule.id > 0)?_c('sub-form',{attrs:{"model":_vm.loginRule,"scenario":"update"}}):_vm._e()],1)],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-hd"},[_c('h4',[_vm._v("编辑限制规则")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4278bee1","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login-rules/update.vue
// module id = 2558
// module chunks = 0